export default __webpack_public_path__ + "static/media/1556.634f7615.png";